import * as qplsService from '../../../services/Qpls/qplsService'
import {gridsNames} from '../../../enums/gridsNames';
import * as gridActionsHelper from 'infrastructure/js/components/Grid/Utils/gridActionsHelper';

const gridActions = gridActionsHelper.getGridActions(gridsNames.ADMINISTRATION_MAT_SETTINGS_QPL_TESTS, _fetchDataAction, _convertToRowData);

function _fetchDataAction(query) {
  return function(dispatch, getState) {

    const qplId = getState().administration.getIn(['matSettingsPage', 'qplForm', 'qplId']);
    query.pageSize = 1000;
    return qplsService.fetchQplTests(qplId, query);
  }
}

function _convertToRowData(rows) {
  return rows;
}

export let actionTypes = gridActions.actionTypes, api = gridActions.apiActions, jsxActions = gridActions.jsxActions;
